import React, { useState, useEffect } from 'react';
import moment from 'moment-timezone';
import axios from 'axios';
import SyncFilter from './SyncFilter';
import constants from '../../constants/index';
import { cookieStorageUtility } from '../../utils/utilityFunctions';

const { serverUrl, ENCRYPTOR_KEY } = constants;
const authUserId = cookieStorageUtility.fetch('auth_user_id');
const encryptedToken = cookieStorageUtility.fetch('encrypted_' + ENCRYPTOR_KEY + '_token');

const ChannelSync = () => {
  const [searchParam, setSearchParam] = useState({
    hotelId: '',
    channelId: 0,
    status: 'all',
    requestType: 'all',
    searchBy: 'requested_date',
    fromDate:'',
    toDate: '',
    pmsCategoryId: ''
  });

  const [ota, setOta] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [categoHide, setCategoHide] = useState(true);

  const [flag, setFlag] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('success');

  useEffect(() => {
    getOTAList();
  }, []);

  const getOTAList = () => {
    axios(`${serverUrl}common/getotalist`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      }
    })
      .then(response => {
        if (response.status === 200) {
          setOta(response.data);
        }
      })
      .catch(error => {
        console.error(error);
      });
  };

  const setMessageWithTimeout = (type, text) => {
    setMessageType(type);
    setMessage(text);
    setFlag(true);
    setTimeout(() => {
      setFlag(false);
    }, 3000);
  };

  const dateChange = (date, type) => {
    const newDate = moment(date).format('YYYY-MM-DD');
    setSearchParam(prev => ({ ...prev, [type]: newDate }));
  };

  const paramChange = (e, type) => {
    if (type === 'hotelName') {
      setSearchParam(prev => ({
        ...prev,
        hotelId: e.length > 0 ? e[0].hotel_id : '',
        hotelName: e.length > 0 ? e[0].hotel : ''
      }));
    } else {
      setSearchParam(prev => ({
        ...prev,
        [type]: e.target.value
      }));
    }
  };

  const typeheadInputChange = (selected, type) => {
    if (type === 'hotelName' && selected.length === 0) {
      setCategoryList([]);
    }
  };

  const reset = () => {
    setSearchParam({
      hotelId: '',
      channelId: 0,
      status: 'all',
      requestType: 'all',
      searchBy: 'requested_date',
      fromDate: moment().subtract(1, 'days').format('YYYY-MM-DD'),
      toDate: moment().format('YYYY-MM-DD'),
      pmsCategoryId: ''
    });
    setCategoryList([]);
    setCategoHide(true);
  };

  const searchLogs = () => {
    const { fromDate, toDate, hotelId, channelId } = searchParam;

    // ✅ Validation
    if (!fromDate && !toDate) {
      setMessageWithTimeout('error', 'Please select both Start Date and End Date.');
      return;
    }

    if (!fromDate) {
      setMessageWithTimeout('error', 'Please enter Start Date.');
      return;
    }

    if (!toDate) {
      setMessageWithTimeout('error', 'Please select End Date.');
      return;
    }

    if (!hotelId && !channelId) {
      setMessageWithTimeout('error', 'Please select either Hotel or Channel.');
      return;
    }

    // ✅ Trigger API
    axios(`${serverUrl}channel/channel_hotel_sync`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: {
        from_date: fromDate,
        to_date: toDate,
        hotel_id: hotelId || null,
        channel_id: channelId !== 0 ? channelId : null
      }
    })
      .then(response => {
        const { data } = response;
        if (data.status_code === 200) {
          setMessageWithTimeout('success', data.message || 'Sync triggered successfully.');
        } else {
          setMessageWithTimeout('error', data.message || 'Sync failed.');
        }
      })
      .catch(error => {
        console.error('API Error:', error);
        setMessageWithTimeout('error', 'An error occurred while syncing.');
      });
  };

  return (
    <div className="channel-sync-page">
      {/* Notification Message Box */}
      {flag && (
        <div
          className={`alert_col posfixed pad10 tc fnt16 bld ${
            messageType === 'error' ? 'danger' : 'success'
          }`}
        >
          {message}
        </div>
      )}

      <div className="container_fluid topheading pad_lft_rht25 pad_top_bot15 text-start">
        <div className="row">
          <div className="col-xs">
            <div className="d-full-height justify-content-center fnt18 tu">Channel Sync</div>
          </div>
        </div>
      </div>

      <SyncFilter
        params={searchParam}
        dateChange={dateChange}
        paramChange={paramChange}
        searchLogs={searchLogs}
        ota={ota}
        reset={reset}
        categoryList={categoryList}
        categoHide={categoHide}
        typeheadInputChange={typeheadInputChange}
      />

      {/* Placeholder for logs or sync status */}
    </div>
  );
};

export default ChannelSync;
